// lib/safetwin
import { compareSHA256 } from "lib/safetwin/crypto/cryptolibsodium";

// features/databox
import getTagInfo from "features/databox/getTagInfo";

// features/user
import getPublicKey from "features/user/getPublicKey";
import getPubKeyUrl from "features/user/getPubKeyUrl";

// features/record
import fetchBlockchainRecord from "features/record/fetchBlockchainRecord";

import { calculateRecordHash } from "./calculateRecordHash";

// A ---------------------------------------------------------------------- M

const verifySignatureGeneric = async (userId, record, type, txidField = "txid") => {
  try {
    const hash = await calculateRecordHash(record, type);
    if (hash === null) return null;

    const txid = record[txidField];
    const pubkey = await getPublicKey(record.creator_uuid);
    const pubkeyURL = await getPubKeyUrl(record.creator_uuid);
    const bcRecord = await fetchBlockchainRecord(txid, pubkey, pubkeyURL);

    if (bcRecord.error) return { tx_not_found: true };

    const check = compareSHA256(bcRecord.txbody.hsh, hash);

    const baseResult = {
      check,
      timestamp: record.data.timestamp,
      record_hash: hash,
      pubkey,
      pubkeyURL,
      confirmed: bcRecord.confirmed,
      key_source: bcRecord.key_source,
      txid: bcRecord.txid,
      tx_timestamp: bcRecord.tx_timestamp,
      signature_status: bcRecord.signature_status,
      server_id: bcRecord.server_id,
      server_id_available: bcRecord.server_id_available,
      hrt: bcRecord.txbody.hrt,
      hsh: bcRecord.txbody.hsh,
      sig: bcRecord.txbody.sig,
    };

    if (bcRecord.txbody.tdr) {
      const tagInfo = await getTagInfo(bcRecord.txbody.tdr);
      return { ...baseResult, tagname: tagInfo?.name || "", tdr: bcRecord.txbody.tdr };
    }

    return baseResult;
  } catch (error) {
    console.error(`Error in verifySignature for ${txidField} ${record[txidField]}:`, error);
    return null;
  }
};

export default verifySignatureGeneric;
